import { useHomepagePageFcm } from 'src/app/pages/homepage/pageContext';

export function useFolksonomyTopics(): boolean | undefined {
	const { folksonomyTopics } = useHomepagePageFcm();

	return folksonomyTopics;
}
